import type { IntegrationHostName } from '@frameio/shared/contexts/ClientNameContext';

export type IntegrationHostMap<T> = Record<IntegrationHostName, T>;

export function isIntegrationHostMapKey<T>(
  map: IntegrationHostMap<T>,
  hostName: string
): hostName is IntegrationHostName {
  return Object.hasOwn(map, hostName);
}

export function getValueForHost<T>(
  map: IntegrationHostMap<T>,
  hostName: string | null | undefined
): T | null {
  if (!hostName || !isIntegrationHostMapKey(map, hostName)) {
    return null;
  }
  return map[hostName];
}
